import React, { useState, useRef, useLayoutEffect } from 'react';
import { PropTypes } from 'prop-types';
import { CarouselProvider, Slider, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

const TemplateCarouselSlider_nobtn = ({ boxStyle, slideBoxSet, contentSet, contentCount, sliderId }) => {
  const [visibleSlides, setVisibleSlides] = useState(1);
  const slideBoxSize = slideBoxSet.width + slideBoxSet.margin * 2;
  const messageBoxDef = useRef(0);
  const [currentSlide, setCurrentSlide] = useState(0);

  useLayoutEffect(() => {
    let clientWidth = messageBoxDef.current.clientWidth;
    setVisibleSlides(clientWidth / slideBoxSize);
    function handleResize() {
      clientWidth = messageBoxDef.current.clientWidth;
      setVisibleSlides(clientWidth / slideBoxSize);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [slideBoxSize]);

  return (
    <div className="_carousel_div" ref={messageBoxDef}>
      <CarouselProvider
        visibleSlides={visibleSlides}
        className="_message_temp_carousel_div"
        totalSlides={contentCount}
        dragEnabled={false}
        isPlaying={false}
        touchEnabled={false}
        currentSlide={currentSlide}
      >
        <Slider style={{ outline: 'none' }} id={sliderId}>
          {contentSet()}
        </Slider>
      </CarouselProvider>
    </div>
  );
};

TemplateCarouselSlider_nobtn.propTypes = {
  boxStyle: PropTypes.object,
  slideBoxSet: PropTypes.object,
  contentCount: PropTypes.number,
  contentSet: PropTypes.func,
  sliderId: PropTypes.string,
};

TemplateCarouselSlider_nobtn.defaultProps = {
  boxStyle: {},
  slideBoxSet: { width: 320, margin: 15, height: '200px' },
  contentCount: 0,
  contentSet: () => {},
  sliderId: 'slider',
};

export default TemplateCarouselSlider_nobtn;
